var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tasks.data)?_c('div',{ref:"gantt"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }